import React, { Component } from 'react';
import { userService } from '../_services';
import loader from '../../src/components/css/dark/img/loader.gif';

import $ from 'jquery';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            submitted: false,
            loading: false,
            error: '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        $('.help-block').html('');
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    componentDidMount() {
        document.title = 'Reset Password Page';
    }
    handleSubmit(e) {
        e.preventDefault();
        $('#userEmail').removeClass('errorIcon');
        this.setState({ loading: true });
        let userEmail = $('#userEmail').val();
        if (userEmail == '' || userEmail == null || userEmail == undefined) {
            $('#userEmail').addClass('errorIcon');
            this.setState({ submitted: true, username: null, loading: false });
        } else {
            this.RequestForPWDForget(userEmail, window.location.origin);
        }

    }
    RequestForPWDForget(UserEmail, RequestURL) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ UserEmail, RequestURL })
        };
        return fetch(`/api/Account/requestpwdreset`, requestOptions)
            .then(this.handleResponse)
            .then(user => {
                try {
                    $('#userEmail').removeClass('errorIcon');
                    this.setState({ loading: false });
                    if (user) {
                        if (user.length > 0) {
                            if (user[0].status_code == "1") {
                                try {
                                    window.location.href = window.location.origin + '/passwordChanged';
                                } catch (error) { }
                            }
                            else {
                                this.setState({ submitted: true, username: null });
                                $('.help-block').html(user[0].status_message);
                                $('#userEmail').addClass('errorIcon');
                            }
                        }
                        else {
                            this.setState({ submitted: true, username: null });
                            $('#userEmail').addClass('errorIcon');
                            $('.help-block').html('Please try after sometime');
                        }
                    }
                    else {
                        this.setState({ submitted: true, username: null });
                        $('#userEmail').addClass('errorIcon');
                        $('.help-block').html('Please try after sometime');
                    }
                }
                catch (error) {
                    this.setState({ loading: false });
                    this.setState({ submitted: true, username: null });
                    $('#userEmail').addClass('errorIcon');
                    $('.help-block').html('Please try after sometime');
                }

            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    render() {
        let logoUrl = '';
        if (window.location.host.toLowerCase() == "reporting.patientrxdiscount.com") {
            logoUrl = window.location.origin + '/Patient-Rx-Discount.svg';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "glichealth.com" && window.location.host.toLowerCase() != "tempfilter-dev.glichealth.com") {
            logoUrl = window.location.origin + '/GlicHealth_logo.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            logoUrl = window.location.origin + '/Rxhacker_logo_new.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "honestdiscounts.com") {
            logoUrl = '/hdrx-logo.svg';
        } else {
            logoUrl = window.location.origin + '/GlicHealth_logo.png';//window.location.origin+'/hdrx-logo.svg';
        }

        const { username, password, submitted, loading, error } = this.state;
        return (
            <div className="reset-password">
                <div className="main">
                    <div className="left-one">
                        <div className="content">
                            <div className="adjust-content">
                                <img className="honest-logo" src={window.location.host.toLowerCase() == "reporting.patientrxdiscount.com" ? window.location.origin + '/Patient-Rx-Discount.svg' : logoUrl} crossorigin="anonymous" alt="logo" />
                                <div className="col-md-6 col-md-offset-3">
                                    <form name="form" onSubmit={this.handleSubmit}>
                                        <h3>Reset Password</h3>
                                        <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                                            <input type="email" id="userEmail" className="form-control userwidth" name="username" placeholder='you@example.com' value={username} onChange={this.handleChange} />
                                            {submitted && !username &&
                                                <div className="help-block">Email address is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <button className="signInButton btn" disabled={loading}>Reset Password</button>
                                            {loading &&
                                                <div className="load-container"><div className="theme-loader"></div></div>
                                            }
                                        </div>
                                        {error &&
                                            <div className={'alert alert-danger'}>{error}</div>
                                        }
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ResetPassword;